// Module
var code = "<table class=\"table report-table\">\n    <thead></thead>\n    <tfoot>\n        <tr><td colspan=\"6\">\n            <span id=\"delete-all-balances\" class=\"clickable\">Delete all balances</span>\n        </td></tr>\n    </tfoot>\n    <tbody></tbody>\n</table>";
// Exports
module.exports = code;